import { LoginParams } from 'enonic-types/auth';
import superagent, { Response, ResponseError } from 'superagent';

export const getConfig = async () => {
  let res;

  try {
    res = await superagent
      .post(`/_/idprovider/gjensidige-id-provider/config`)
      .accept('application/json')
      .send();

    return res.body;
  } catch (e) {
    console.error(e);
  }

  return res ? res.body : res;
};

export const login = async (body: LoginParams) => {
  try {
    return (await superagent
      .post(`/_/idprovider/gjensidige-id-provider/login`)
      .withCredentials()
      .send(body)) as Response;
  } catch (err) {
    return err as ResponseError;
  }
};

export const registerUser = async (
  name: string,
  email: string,
  password: string
) => {
  try {
    return (await superagent
      .post(`/_/idprovider/gjensidige-id-provider/register`)
      .send({ name, email, password })) as Response;
  } catch (err) {
    return err as ResponseError;
  }
};

export const forgotPassword = async (email: string) => {
  let res;
  try {
    res = await superagent
      .post(`/_/idprovider/gjensidige-id-provider/forgot-password`)
      .send({ email });
    return res;
  } catch (err) {
    console.log(err);
    return res;
  }
};

export const changePassword = async (body: LoginParams) => {
  let res;
  try {
    res = await superagent
      .post(`/_/idprovider/gjensidige-id-provider/change-password`)
      .send(body);
    return res;
  } catch (err) {
    console.log(err);
    return res;
  }
};

export const logout = async () => {
  let res;
  try {
    res = await superagent
      .post(`/_/idprovider/gjensidige-id-provider/logout`)
      .withCredentials();
    return res;
  } catch (err) {
    console.log(err);
    return res;
  }
};
